<template>
  <el-dialog
    v-bind="$attrs"
    :model-value="modelValue"
    class="confirm-dialog-common"
    :title="displayTitle"
    width="332px"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="teleport"
  >
    <div class="dialog-body">{{ contentText }}</div>
    <div class="footer">
      <div v-if="!hidden.includes('确定')" class="btn confirm" @click="handleConfirm">
        {{ displayConfirmButtonText }}
      </div>
      <div v-if="!hidden.includes('取消')" class="btn" @click="handleClosed">
        {{ displayCancelButtonText }}
      </div>
    </div>
  </el-dialog>
</template>

<script lang="ts">
  export default {
    name: 'CommonCustomConfirmDialog'
  }
</script>

<script setup lang="ts">
  import { onBeforeMount } from 'vue'
  import { useI18n } from 'vue-i18n'
  const props = withDefaults(
    defineProps<{
      modelValue: boolean
      title?: string
      contentText: string
      confirmButtonText?: string
      cancelButtonText?: string
      teleport?: boolean
      hidden?: string
    }>(),
    {
      title: '',
      confirmButtonText: '',
      cancelButtonText: '',
      teleport: true,
      hidden: ''
    }
  )

  const { t } = useI18n()
  const displayTitle = props.title === '' ? t('global.tip') : props.title
  const displayConfirmButtonText =
    props.confirmButtonText === '' ? t('global.confirm') : props.confirmButtonText
  const displayCancelButtonText =
    props.cancelButtonText === '' ? t('global.cancel') : props.cancelButtonText
  const emits = defineEmits(['update:modelValue', 'submit', 'close'])
  /**
   * 关闭
   */
  const handleClosed = () => {
    emits('close')
    emits('update:modelValue', false)
  }
  /**
   * 确定
   */
  const handleConfirm = () => {
    emits('submit')
    emits('update:modelValue', false)
  }
</script>

<style lang="scss">
  .confirm-dialog-common {
    border-radius: 36px !important;
    overflow: hidden !important;
    background-color: var(--bg-color-primary) !important;
    border: 1px solid var(--border-color-blue) !important;
    .el-dialog__header {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 118px;
      font-size: 16px;
      font-weight: bold;
      background: url('../../assets/images/message-box.png') no-repeat top left;

      margin-right: 0;

      .el-dialog__title {
        color: var(--text-color-primary);
        letter-spacing: 1em;
      }
    }
    .el-dialog__body {
      padding: 0;
    }
    .dialog-body {
      min-height: 135px;
      padding-top: 36px;
      padding-left: 45px;
      padding-right: 36px;
      color: var(--text-color-primary);
      line-height: 2;
    }
    .footer {
      display: flex;
      height: 51px;
      text-align: center;
      color: var(--text-color-four);
      font-weight: 500;
      letter-spacing: 2px;
      .btn {
        flex: 1;
        height: 100%;
        border-top: 1px solid var(--border-color-9);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .confirm {
        border-color: var(--border-color-focus);
        background-color: var(--bg-color-focus);
        color: var(--text-color-black);
      }
    }
  }
</style>
